import {
  EnvironmentProviders,
  importProvidersFrom,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';
import {
  NativeDateTimeAdapter,
  OWL_DATE_TIME_LOCALE,
  OwlDateTimeIntl,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { EngineCultureService } from '@core/engine-culture/services/culture.service';
import { OWL_DATE_ADAPTER } from '@shared/reactive-controls/components/date/date-control.component';
import { OWL_DATE_TIME_ADAPTER } from '@shared/reactive-controls/components/datetime/datetime-control.component';
import { OwlDateAdapter } from './services/owl-date-adapter.service';
import { OwlDateTimeAdapter } from './services/owl-date-time-adapter.service';
import { OwlIntlService } from './services/owl-intl.service';

export function provideOwlDateTime(): EnvironmentProviders {
  return makeEnvironmentProviders([
    importProvidersFrom(OwlDateTimeModule, OwlNativeDateTimeModule),
    NativeDateTimeAdapter,
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' },
    OwlIntlService,
    { provide: OwlDateTimeIntl, useExisting: OwlIntlService },
    OwlDateAdapter,
    { provide: OWL_DATE_ADAPTER, useExisting: OwlDateAdapter },
    OwlDateTimeAdapter,
    { provide: OWL_DATE_TIME_ADAPTER, useExisting: OwlDateTimeAdapter },
    provideEnvironmentInitializer(() => {
      const cultureService = inject(EngineCultureService);
      const nativeAdapter = inject(NativeDateTimeAdapter);
      const customAdapter = inject(OwlDateTimeAdapter);
      const intlService = inject(OwlIntlService);

      if (!cultureService.cultureSettings) return;
      nativeAdapter.setLocale(cultureService.cultureSettings.code);
      customAdapter.setLocale(cultureService.cultureSettings.code);
      intlService.updateTranslations({ ...intlService.translations });
    }),
  ]);
}
